
export const PM_GATE_DETAIL = "PM_GATE_DETAIL";
export const PM_CHECKLIST = "PM_CHECKLIST";
export const ADD_CATEGORY_TYPE = "ADD_CATEGORY_TYPE";
export const CATEGORY_TYPE = "CATEGORY_TYPE";
export const SUB_CATEGORY_TYPE = "SUB_CATEGORY_TYPE";
export const PM_GATE = "PM_GATE";
export const SCHEDULED_TICKETS = "SCHEDULED_TICKETS";
export const ADD_CATEGORY_LIST = "ADD_CATEGORY_LIST";
export const ENGINEER_LIST = 'ENGINEER_LIST';
export const PM_PROJECT_CHECKLIST='PM_PROJECT_CHECKLIST'


